import AddNewLanguageForm from './AddNewLanguageForm'

export default AddNewLanguageForm
